/**
 * Movie Page - Uses unified content page
 */
import React from "react";
import { ContentPage } from "../../components/content";

const MoviePage = () => {
  return <ContentPage />;
};

export default MoviePage;
